<template>
  <div>
    <layout-header></layout-header>
    <layout-sidebar></layout-sidebar>
    <InLoader class="inloader" />
    <OTP id="OTP_modal" />
    <OTP2 id="OTP_modal2" />

    <div class="page-wrapper">
      <div class="content">
        <div class="row">
          <div class="col-xl-3 col-sm-6 col-12 d-flex">
            <div class="dash-widget w-100">
              <div class="dash-widgetimg">
                <span
                  ><img src="@/assets/img/icons/dash1.svg" alt="img"
                /></span>
              </div>
              <div class="dash-widgetcontent">
                <h5>
                  ₦
                  <vue3-autocounter
                    class="counters"
                    ref="counter"
                    :startAmount="0"
                    :delay="1"
                    :endAmount="returned_data.total_sales_amount"
                    :duration="5"
                    :autoinit="true"
                  />
                </h5>
                <h6>Total Sales</h6>
              </div>
            </div>
          </div>
          <div class="col-xl-3 col-sm-6 col-12 d-flex">
            <div class="dash-widget dash1 w-100">
              <div class="dash-widgetimg">
                <span
                  ><img src="@/assets/img/icons/dash2.svg" alt="img"
                /></span>
              </div>
              <div class="dash-widgetcontent">
                <h5>
                  ₦
                  <vue3-autocounter
                    class="counters"
                    ref="counter"
                    :startAmount="0"
                    :delay="1"
                    :endAmount="returned_data.current_ledger"
                    :duration="5"
                    :autoinit="true"
                  />
                </h5>
                <h6>Total Current Ledger</h6>
              </div>
            </div>
          </div>
          <div class="col-xl-3 col-sm-6 col-12 d-flex">
            <div class="dash-widget dash2 w-100">
              <div class="dash-widgetimg">
                <span
                  ><img src="@/assets/img/icons/dash3.svg" alt="img"
                /></span>
              </div>
              <div class="dash-widgetcontent">
                <h5>
                  ₦
                  <vue3-autocounter
                    class="counters"
                    ref="counter"
                    :startAmount="0"
                    :delay="3"
                    :endAmount="returned_data.total_coin_sales"
                    :duration="5"
                    :autoinit="true"
                  />
                </h5>
                <h6>Total Coin Sales</h6>
              </div>
            </div>
          </div>
          <div class="col-xl-3 col-sm-6 col-12 d-flex">
            <div class="dash-widget dash3 w-100">
              <div class="dash-widgetimg">
                <span
                  ><img src="@/assets/img/icons/dash4.svg" alt="img"
                /></span>
              </div>
              <div class="dash-widgetcontent">
                <h5>
                  ₦
                  <vue3-autocounter
                    class="counters"
                    ref="counter"
                    :startAmount="0"
                    :delay="1"
                    :endAmount="returned_data.available_balance"
                    :duration="5"
                    :autoinit="true"
                  />
                </h5>
                <h6>Total Available Balance</h6>

                <div class="" id="item_code">
                  <button
                    type="submit"
                    class="btn btn-primaryadd"
                    data-bs-toggle="modal"
                    href="#exampleModalToggle"
                  >
                    Withdraw
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xl-3 col-sm-6 col-12 d-flex">
            <div class="dash-count">
              <div class="dash-counts">
                <h4>{{ returned_data.total_orders }}</h4>
                <h5>Total Order Recieved</h5>
              </div>
              <div class="dash-imgs">
                <vue-feather type="user"></vue-feather>
              </div>
            </div>
          </div>
          <div class="col-xl-3 col-sm-6 col-12 d-flex">
            <div class="dash-count das1">
              <div class="dash-counts">
                <h4>{{ returned_data.completed_orders }}</h4>
                <h5>Total Order Packed</h5>
              </div>
              <div class="dash-imgs">
                <vue-feather type="user-check"></vue-feather>
              </div>
            </div>
          </div>
          <div class="col-xl-3 col-sm-6 col-12 d-flex">
            <div class="dash-count das2">
              <div class="dash-counts">
                <h4>{{ returned_data.total_shipped_orders }}</h4>
                <h5>Total Order Shipped</h5>
              </div>
              <div class="dash-imgs">
                <img
                  src="@/assets/img/icons/file-text-icon-01.svg"
                  class="img-fluid"
                  alt="icon"
                />
              </div>
            </div>
          </div>
          <div class="col-xl-3 col-sm-6 col-12 d-flex">
            <div class="dash-count das3">
              <div class="dash-counts">
                <h4>{{ returned_data.completed_orders }}</h4>
                <h5>Total Order Completed</h5>
              </div>
              <div class="dash-imgs">
                <vue-feather type="file"></vue-feather>
              </div>
            </div>
          </div>
        </div>
        <!-- Button trigger modal -->

        <div class="row" hidden>
          <div class="col-xl-6 col-sm-12 col-12 d-flex">
            <div class="card flex-fill">
              <div
                class="card-header d-flex justify-content-between align-items-center"
              >
                <h5 class="card-title mb-0">Purchase & Sales</h5>
                <div class="graph-sets">
                  <ul class="mb-0">
                    <li>
                      <span>Sales</span>
                    </li>
                    <li>
                      <span>Purchase</span>
                    </li>
                  </ul>
                  <div class="dropdown dropdown-wraper">
                    <button
                      class="btn btn-light btn-sm dropdown-toggle"
                      type="button"
                      id="dropdownMenuButton"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      2024
                    </button>
                    <ul
                      class="dropdown-menu"
                      aria-labelledby="dropdownMenuButton"
                    >
                      <li>
                        <a href="javascript:void(0);" class="dropdown-item"
                          >2024</a
                        >
                      </li>
                      <li>
                        <a href="javascript:void(0);" class="dropdown-item"
                          >2023</a
                        >
                      </li>
                      <li>
                        <a href="javascript:void(0);" class="dropdown-item"
                          >2022</a
                        >
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="card-body">
                <div id="sales_charts"></div>
                <apexchart
                  type="bar"
                  height="300"
                  :options="basicAreaChart.sline"
                  :series="basicAreaChart.series"
                ></apexchart>
              </div>
            </div>
          </div>
          <div class="col-xl-6 col-sm-12 col-12 d-flex">
            <!-- World Map -->
            <div class="card default-cover" hidden>
              <div
                class="card-header d-flex justify-content-between align-items-center"
              >
                <h5 class="card-title mb-0">Sales by Countries</h5>
                <div class="graph-sets">
                  <div class="dropdown dropdown-wraper">
                    <button
                      class="btn btn-white btn-sm dropdown-toggle d-flex align-items-center"
                      type="button"
                      id="dropdown-country-sales"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      This Week
                    </button>
                    <ul
                      class="dropdown-menu"
                      aria-labelledby="dropdown-country-sales"
                    >
                      <li>
                        <a href="javascript:void(0);" class="dropdown-item"
                          >This Month</a
                        >
                      </li>
                      <li>
                        <a href="javascript:void(0);" class="dropdown-item"
                          >This Year</a
                        >
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="card-body">
                <div id="sales_db_world_map" style="height: 265px">
                  <vector-map></vector-map>
                </div>
                <p class="sales-range">
                  <span class="text-success"
                    ><vue-feather
                      type="chevron-up"
                      class="feather-16"
                    ></vue-feather
                    >48%&nbsp;</span
                  >increase compare to last week
                </p>
              </div>
            </div>
            <!-- /World Map -->
          </div>
        </div>
        <div class="row">
          <div class="col-xl-6 col-sm-12 col-12 d-flex">
            <div class="card flex-fill default-cover mb-4">
              <div
                class="card-header d-flex justify-content-between align-items-center"
              >
                <h4 class="card-title mb-0">Recent Sales</h4>
                <div class="view-all-link">
                  <router-link
                    to="/purchases/purchase-list"
                    class="view-all d-flex align-items-center"
                  >
                    View All<span class="ps-2 d-flex align-items-center"
                      ><vue-feather
                        type="arrow-right"
                        class="feather-16"
                      ></vue-feather
                    ></span>
                  </router-link>
                </div>
              </div>
              <div class="card-body">
                <div
                  class="table-responsive dataview"
                  style="overflow-x: hidden"
                >
                  <table class="table dashboard-recent-products">
                    <thead>
                      <tr>
                        <th class="no-sort">
                          <label class="checkboxs">
                            <input type="checkbox" id="select-all" />
                            <span class="checkmarks"></span>
                          </label>
                        </th>
                        <th>#</th>
                        <th>Products</th>
                        <th>Price</th>
                        <th>Order Status</th>
                        <th>Shipping Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="item in AdminSales" :key="item.id">
                        <td>
                          <label class="checkboxs">
                            <input type="checkbox" />
                            <span class="checkmarks"></span>
                          </label>
                        </td>
                        <td>#{{ item.public_ref }}</td>
                        <td class="productimgname">
                          {{ item.products }}
                        </td>
                        <td>{{ item.amount }}</td>
                        <td>
                          <span
                            class="badges status-badge"
                            v-if="item.shipping_status == 'Paid'"
                            >{{ item.shipping_status }}</span
                          >
                          <span
                            class="badges status-badge"
                            v-if="item.shipping_status == 'Shipped'"
                            >{{ item.shipping_status }}</span
                          >
                          <span
                            class="badges status-badge"
                            v-if="item.shipping_status == 'Fulfilled'"
                            >{{ item.shipping_status }}</span
                          >
                          <!-- <span
                              class="badges unstatus-badge"
                              v-if="item.shipping_status == 'Cancelling'"
                              >{{ item.shipping_status }}</span
                            > -->
                          <span
                            class="badges unstatus-badge"
                            v-if="item.shipping_status == 'Cancelled'"
                            >{{ item.shipping_status }}</span
                          >
                          <span
                            class="badges status-badge"
                            v-if="item.shipping_status == 'Delivered'"
                            >{{ item.shipping_status }}</span
                          >
                        </td>
                        <td>
                          <span
                            class="badges status-badge"
                            v-if="item.order_status == 'Paid'"
                            >{{ item.order_status }}</span
                          >
                          <span
                            class="badges status-badge"
                            v-if="item.order_status == 'Delivered'"
                            >{{ item.order_status }}</span
                          >
                          <span
                            class="badges unstatus-badge"
                            v-if="item.order_status == 'Unpaid'"
                            >{{ item.order_status }}</span
                          >
                          <span
                            class="badges unstatus-badge"
                            v-if="item.order_status == 'Cancelled'"
                            >{{ item.order_status }}</span
                          >
                          <span
                            class="badges status-badge"
                            v-if="item.order_status == 'Fulfilled'"
                            >{{ item.order_status }}</span
                          >
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xl-6 col-sm-12 col-12 d-flex">
            <div class="card" style="width: 100%">
              <div
                class="card-header d-flex justify-content-between align-items-center"
              >
                <h4 class="card-title mb-0">Recent Withdrawals</h4>
                <div class="view-all-link">
                  <router-link
                    to="/Widthrawal"
                    class="view-all d-flex align-items-center"
                  >
                    View All<span class="ps-2 d-flex align-items-center"
                      ><vue-feather
                        type="arrow-right"
                        class="feather-16"
                      ></vue-feather
                    ></span>
                  </router-link>
                </div>
              </div>
              <div class="card-body">
                <div
                  class="table-responsive dataview"
                  style="overflow-x: hidden"
                >
                  <table class="table dashboard-expired-products">
                    <thead>
                      <tr>
                        <th class="no-sort">
                          <label class="checkboxs">
                            <input type="checkbox" id="select-all" />
                            <span class="checkmarks"></span>
                          </label>
                        </th>

                        <th>Amount</th>
                        <th>Payment Method</th>
                        <th>Account Name</th>
                        <th>Account Number</th>
                        <th>Status</th>
                        <!-- <th>TXN Ref</th> -->
                        <th>View Slip</th>
                        <!-- <th class="no-sort">Action</th> -->
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="item in withdraws" :key="item.id">
                        <td>
                          <label class="checkboxs">
                            <input type="checkbox" />
                            <span class="checkmarks"></span>
                          </label>
                        </td>
                        <td>
                          <a href="javascript:void(0);"
                            >{{ splitNumbersWithComma(item?.amount) }}
                          </a>
                        </td>
                        <td>Bank</td>
                        <td>
                          {{ item.bank_details.surname }}
                          {{ item.bank_details.other_names }}
                        </td>
                        <td>{{ item.bank_details.account_number }}</td>
                        <td>
                          <span
                            class="badges status-badge"
                            v-if="item.status == 'Success'"
                            >{{ item.status }}</span
                          >
                          <span
                            class="badge badge-warning"
                            v-if="item.status == 'Pending'"
                            >{{ item.status }}</span
                          >
                        </td>
                        <td class="action-table-data">
                          <div class="edit-delete-action">
                            <a
                              class="me-2 p-2"
                              href="javascript:void(0);"
                              @click="view_withdrawal(item)"
                            >
                              View
                            </a>
                            <!-- <a
                          class="confirm-text p-2"
                          @click="showConfirmation"
                          href="javascript:void(0);"
                        >
                          <vue-feather
                            type="trash-2"
                            class="feather-trash-2"
                          ></vue-feather>
                        </a> -->
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Static Backdrop -->

  <!-- Modal -->
  <div class="col-xl-4">
    <div
      class="modal fade"
      id="staticBackdrop"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      tabindex="-1"
      aria-labelledby="staticBackdropLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="staticBackdropLabel">
              Complete Your KYC
            </h5>
            <!-- <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button> -->
          </div>
          <div class="modal-body">
            You have not verified your indentity yet. Please verify yourself to
            get full access to our sell features.
          </div>
          <div class="modal-footer">
            <div @click="logout()" class="btn btn-cancel">Sign out</div>
            <a :href="kycUrl('9')" class="btn btn-primary" target="_blank"
              >Proceed to KYC</a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Static Backdrop -->

  <!-- withdrawal modal -->
  <!-- Toggle Between Modals -->
  <div class="col-xl-4">
    <!-- Modal -->
    <div
      class="modal fade"
      id="exampleModalToggle"
      aria-hidden="true"
      aria-labelledby="exampleModalToggleLabel"
      tabindex="-1"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title" id="exampleModalToggleLabel">
              Request Payout
            </h4>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <div>
              <div class="balance-card">
                <div class="bal-content">
                  <div style="display: inline-block" class="icon_cont">
                    <span class="fa fa-wallet wallet_icon"></span>
                  </div>
                  <div style="display: inline-block">
                    <h5 class="bal">
                      ₦
                      <vue3-autocounter
                        class="counters"
                        ref="counter"
                        :startAmount="0"
                        :delay="1"
                        :endAmount="returned_data.available_balance"
                        :duration="5"
                        :autoinit="true"
                      />
                    </h5>
                    <p style="color: rgb(255, 255, 255)">Available Balance</p>
                  </div>
                </div>
              </div>
            </div>
            <center v-if="returned_data.available_balance < withdraw_amount">
              <span style="color: red"
                >Your balance is less than your request!</span
              >
            </center>
            <form class="">
              <div id="input-group-1" role="group" class="form-group">
                <label id="" for="input-1" class="d-block"
                  >Enter the amount you want to withdraw:</label
                >
                <div>
                  <input
                    id="input-1"
                    type="number"
                    placeholder="Enter Amount"
                    required="required"
                    aria-required="true"
                    class="form-control"
                    v-model="withdraw_amount"
                  /><!----><!----><!---->
                </div>
              </div>
            </form>
          </div>
          <!-- :disabled="withdraw_amount < 1000 && withdraw_amount === ''" -->

          <div class="modal-footer">
            <button
              class="btn btn-primary"
              data-bs-target="#exampleModalToggle2"
              data-bs-toggle="modal"
              data-bs-dismiss="modal"
              style="width: 100%"
              :disabled="withdraw_amount < 1000"
              @click="get_banks_accounts()"
            >
              CONTINUE
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- /Modal -->

    <!-- Modal -->
    <div
      class="modal fade"
      id="exampleModalToggle2"
      aria-hidden="true"
      aria-labelledby="exampleModalToggleLabel2"
      tabindex="-1"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title" id="exampleModalToggleLabel2">
              Request Payout
            </h4>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <div>
              <div class="balance-card">
                <div class="bal-content">
                  <div style="display: inline-block" class="icon_cont">
                    <span class="fa fa-wallet wallet_icon"></span>
                  </div>
                  <div style="display: inline-block">
                    <h5 class="bal">
                      ₦
                      <vue3-autocounter
                        class="counters"
                        ref="counter"
                        :startAmount="0"
                        :delay="1"
                        :endAmount="returned_data.available_balance"
                        :duration="5"
                        :autoinit="true"
                      />
                    </h5>
                    <p style="color: rgb(255, 255, 255)">Available Balance</p>
                  </div>
                </div>
              </div>
            </div>

            <form class="" v-if="bank_list.length <= 0 || bank_list == null">
              <div id="input-group-1" role="group" class="form-group fg2">
                <label id="" for="input-1" class="d-block"
                  >You have not added a bank yet.
                  <router-link
                    to="/settings/bank-settings-grid"
                    style="color: #00afef"
                  >
                    Add Bank Details</router-link
                  ></label
                >
              </div>
            </form>

            <div class="list_accts" v-else>
              <div class="mt-4">
                <p style="color: rgb(0, 0, 0); margin-bottom: -20px">
                  Select Bank Account:
                </p>

                <div>
                  <div v-for="(bank, index) in bank_list" :key="index" class="">
                    <div
                      :class="{
                        'bank-box': true,
                      }"
                    >
                      <div class="bank-header">
                        <div class="bank-name">
                          <h6>{{ bank.bank }}</h6>
                          <p>{{ bank.account_number }}</p>
                        </div>
                      </div>
                      <div
                        class="d-flex align-items-center justify-content-between"
                      >
                        <div class="bank-info">
                          <span>Holder Name</span>
                          <h6>{{ bank.surname }} {{ bank.other_names }}</h6>
                        </div>
                        <div class="edit-delete-action bank-action-btn">
                          <a
                            class="me-2 p-2 text-light"
                            href="javascript:void(0);"
                            data-bs-target="#confirmModalToggle"
                            data-bs-toggle="modal"
                            data-bs-dismiss="modal"
                            @click="
                              get_selected(
                                bank.bank,
                                bank.surname,
                                bank.other_names,
                                bank.id
                              )
                            "
                          >
                            Select
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              v-if="bank_list.length <= 0 || bank_list == null"
              class="btn btn-primary"
              data-bs-target="#confirmModalToggle"
              data-bs-toggle="modal"
              data-bs-dismiss="modal"
              style="width: 100%"
              disabled
            >
              CONTINUE
            </button>
            <!-- <button
              v-else
              class="btn btn-primary"
              data-bs-target="#confirmModalToggle"
              data-bs-toggle="modal"
              data-bs-dismiss="modal"
              style="width: 100%"
            >
              CONTINUE
            </button> -->
          </div>
        </div>
      </div>
    </div>
    <!-- /Modal -->
  </div>
  <!-- /Toggle Between Modals -->

  <!-- confirm modal -->
  <!-- Toggle Between Modals -->
  <div class="col-xl-4">
    <!-- Modal -->
    <div
      class="modal fade"
      id="confirmModalToggle"
      aria-hidden="true"
      aria-labelledby="confirmModalToggleLabel"
      tabindex="-1"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title" id="confirmModalToggleLabel">
              Request Payout
            </h4>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <!--   verify paymentcontnerts goes here -->
            <div>
              <p>Confirm withrawal details below:</p>
              <div class="py-2">
                <div class="confirm-desc py-2">
                  <div class="confrim-content">
                    <h4 style="font-size: 28px; font-weight: 600">
                      ₦
                      <!-- <vue3-autocounter
                        class="counters"
                        ref="counter"
                        :startAmount="0"
                        :delay="1"
                        :endAmount="withdraw_amount"
                        :duration="5"
                        :autoinit="true"
                      /> -->
                      {{ splitNumbersWithComma(withdraw_amount) }}
                    </h4>
                    <p>Withdrawal Amount</p>
                  </div>
                </div>
              </div>
              <div class="py-2">
                <div class="confirm-desc py-2">
                  <div class="confrim-content">
                    <h4 style="font-size: 28px; font-weight: 600">
                      {{ returned_bank_name }}
                    </h4>
                    <p>{{ returned_bank }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              class="btn btn-primary"
              data-bs-target="#confirmModalToggle2"
              data-bs-toggle="modal"
              data-bs-dismiss="modal"
              style="width: 100%"
            >
              CONTINUE
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- /Modal -->

    <!-- Modal -->
    <div
      class="modal fade"
      id="confirmModalToggle2"
      aria-hidden="true"
      aria-labelledby="confirmModalToggleLabel2"
      tabindex="-1"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title" id="confirmModalToggleLabel2">
              Request Payout
            </h4>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <div class="mt-1">
              <p>You’ll need to enter password to continue.</p>
              <div class="py-2 mt-0">
                <form class="">
                  <div id="input-group-1" role="group" class="form-group">
                    <label id="input-group-1" for="input-1" class="d-block"
                      >Enter your password below:</label
                    >
                    <div>
                      <input
                        id="input-1"
                        type="password"
                        placeholder="Enter Password"
                        class="form-control"
                        v-model="withdraw_password"
                      /><!----><!----><!---->
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <!-- the main action goes here (withdraw)-->
            <div
              class="btn btn-primary"
              style="width: 100%"
              @click="confirm_withdrawal()"
            >
              CONFIRM
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /Modal -->
  </div>
  <!-- /Toggle Between Modals -->

  <div class="col-xl-4">
    <!-- Modal -->
    <div
      class="modal fade"
      id="viewWithdrawal"
      aria-hidden="true"
      aria-labelledby="viewWithdrawal_Label"
      tabindex="-1"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title" id="viewWithdrawal_Label">
              Withdrawal Details
            </h4>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <div class="modal-container">
              <h4>Name:</h4>
              <div class="name-block">
                <p>{{ mutated_item?.bank_details?.surname }}</p>
                <p>{{ mutated_item?.bank_details?.other_names }}</p>
              </div>
            </div>
            <div class="modal-container">
              <h4>Bank Name:</h4>
              <p>{{ mutated_item?.bank_details?.bank }}</p>
            </div>
            <div class="modal-container">
              <h4>Account Number:</h4>
              <p>{{ mutated_item?.bank_details?.account_number }}</p>
            </div>
            <div class="modal-container">
              <h4>Amount:</h4>
              <p>₦ {{ splitNumbersWithComma(mutated_item?.amount) }}</p>
            </div>
            <div class="modal-container">
              <h4>Status:</h4>
              <!----><span class="order-status pending">{{
                mutated_item?.status
              }}</span
              ><!----><!----><!---->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { basicAreaChart } from "./data";
import { mapActions } from "vuex";
import { toast } from "vue3-toastify";
import "vue3-toastify/dist/index.css";

// can remove
import { salesAnalysis } from "./data";
import SalesBest from "@/assets/json/sales-best.json";
import "daterangepicker/daterangepicker.css";
import "daterangepicker/daterangepicker.js";
import { ref } from "vue";
import { onMounted } from "vue";
import moment from "moment";
import DateRangePicker from "daterangepicker";
import { kycUrl } from "@/api";

export default {
  data() {
    return {
      basicAreaChart: basicAreaChart,
      AdminSales: [],
      data: JSON.parse(localStorage.getItem("data")),
      returned_data: "",
      withdraws: [],
      // can remove
      SalesBest: SalesBest,
      salesAnalysis: salesAnalysis,
      withdraw_amount: "",
      k: false,
      bank_list: "",
      returned_bank: "",
      returned_bank_name: "",
      bank_details_id: "",
      withdraw_password: "",
      response: "",
      mutated_item: "",
      kycUrl,
    };
  },
  methods: {
    ...mapActions({
      _get_sales_dashboard: "dashboard/get_sales_dashboard",
      _get_invoices: "general/get_invoices",
      _get_withdrawls: "general/get_withdrawls",
      _get_banks_accounts: "general/get_banks_accounts",
      _confirm_withdrawal: "general/confirm_withdrawal",
    }),

    get_sales_dashboard() {
      this._get_sales_dashboard()
        .then((response) => {
          this.response = response.data;
          if (this.response["status"] == true) {
            this.returned_data = this.response.data;
          }
        })
        .catch((error) => {
          console.log("Error logging in", error);
          if (error.response) {
            const status = error.response.status;
            const data = error.response.data;
            if (
              status == 400 ||
              status == 422 ||
              status == 401 ||
              status == 404
            ) {
            } else if (status === 500) {
            }
          }
        });
    },
    get_invoices() {
      this._get_invoices()
        .then((response) => {
          this.response = response.data;
          if (this.response["status"] == true) {
            this.AdminSales = this.response.data;
            this.AdminSales = this.AdminSales.slice(0, 5);
          }
        })
        .catch((error) => {
          console.log("Error logging in", error);
          if (error.response) {
            const status = error.response.status;
            const data = error.response.data;
            if (
              status == 400 ||
              status == 422 ||
              status == 401 ||
              status == 404
            ) {
            } else if (status === 500) {
            }
          }
        });
    },
    get_withdrawls() {
      this._get_withdrawls()
        .then((response) => {
          this.response = response.data;
          if (this.response["status"] == true) {
            this.withdraws = this.response.data;
            this.withdraws = this.withdraws.reverse();
            this.withdraws = this.withdraws.slice(0, 5);
          }
        })
        .catch((error) => {
          console.log("Error logging in", error);
          if (error.response) {
            const status = error.response.status;
            const data = error.response.data;
            if (
              status == 400 ||
              status == 422 ||
              status == 401 ||
              status == 404
            ) {
            } else if (status === 500) {
            }
          }
        });
    },
    get_banks_accounts() {
      $(".inloader").show();
      this._get_banks_accounts()
        .then((response) => {
          this.response = response.data;
          if (this.response["status"] == true) {
            $(".inloader").hide();

            this.bank_list = this.response.data;
          }
        })
        .catch((error) => {
          $(".inloader").hide();

          console.log("Error logging in", error);
          if (error.response) {
            const status = error.response.status;
            const data = error.response.data;
            if (
              status == 400 ||
              status == 422 ||
              status == 401 ||
              status == 404
            ) {
            } else if (status === 500) {
            }
          }
        });
    },
    confirm_withdrawal() {
      $(".inloader").show();
      this._confirm_withdrawal({
        amount: this.withdraw_amount,
        bank_details_id: this.bank_details_id,
        password: this.withdraw_password,
      })
        .then((response) => {
          $(".inloader").hide();
          toast.success("OTP SENT", {
            position: toast.POSITION.TOP_RIGHT,
          });
          this.response = response.data;
          //   this.response
          if (this.response["status"] == true) {
            var data = this.response.data;
            // alert(data.id);
            localStorage.setItem("withdrawal_id", data.id);
            localStorage.setItem("withdraw_amount", this.withdraw_amount);

            // SHOW OTP MODAL
            $("#confirmModalToggle2").modal("hide");
            $("#OTP_modal2").modal("show");
            this.startCountdown();
          }
        })
        .catch((error) => {
          $(".inloader").hide();

          console.log("Error logging in", error);
          if (error.response) {
            const status = error.response.status;
            const data = error.response.data;
            if (
              status == 400 ||
              status == 422 ||
              status == 401 ||
              status == 404
            ) {
              toast.error(error.response.data.message, {
                position: toast.POSITION.TOP_RIGHT,
              });
            } else if (status === 500) {
              toast.error("Network Error, Check your internet conectivity.", {
                position: toast.POSITION.TOP_RIGHT,
              });
            }
          }
        });
    },

    get_selected(bank, bank_name1, bank_name2, id) {
      this.returned_bank = bank;
      this.returned_bank_name = bank_name1 + " " + bank_name2;
      this.bank_details_id = id;
    },
    view_withdrawal(item) {
      this.mutated_item = item;
      $("#viewWithdrawal").modal("show");
    },
    showConfirmation() {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
        confirmButtonClass: "btn btn-primary",
        cancelButtonClass: "btn btn-danger ml-1",
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          Swal.fire({
            icon: "success",
            title: "Deleted!",
            text: "Your file has been deleted.",
            confirmButtonClass: "btn btn-success",
          });
        }
      });
    },
    logout() {
      window.location = "/";
    },
    show_KYC_modal() {
      const storeId = localStorage.getItem("store_id");
      if (!storeId && this.data.kyc_verified == false) {
        $("#staticBackdrop").modal("show");
      }
    },
    toggleCollapse() {
      const collapseHeader = this.$refs.collapseHeader;

      if (collapseHeader) {
        collapseHeader.classList.toggle("active");
        document.body.classList.toggle("header-collapse");
      }
    },

    updateTimerDisplay(timeInSeconds) {
      // Get the timer element
      const timerElement = document.getElementById("count-down");

      const minutes = Math.floor(timeInSeconds / 60);
      const seconds = timeInSeconds % 60;
      const formattedTime = `${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;
      timerElement.textContent = formattedTime;
    },
    performAction() {
      $("#OTP_modal").modal("hide");
      $(".xvx").show();
    },
    startCountdown() {
      const countdownTime = 5 * 60; // 5 minutes * 60 seconds
      let timeRemaining = countdownTime;
      // Update the display initially
      this.updateTimerDisplay(timeRemaining);

      let _vm = this;
      // Set an interval to update the countdown every second
      const countdownInterval = setInterval(function () {
        timeRemaining--;

        // Update the display
        _vm.updateTimerDisplay(timeRemaining);

        // Check if the countdown reached 0
        if (timeRemaining <= 0) {
          // Clear the interval
          clearInterval(countdownInterval);

          // Perform the action when the countdown reaches 0
          _vm.performAction();
        }
      }, 3000); // Update every 1000 milliseconds (1 second)
    },
    splitNumbersWithComma(number) {
      // Convert number to string to handle cases like decimal numbers
      if (number) {
        let numStr = number.toString();

        // Split the integer and decimal parts if it's a decimal number
        let parts = numStr.split(".");
        let integerPart = parts[0];
        let decimalPart = parts.length > 1 ? "." + parts[1] : "";

        // Insert commas for thousands separator in the integer part
        let integerWithCommas = integerPart.replace(
          /\B(?=(\d{3})+(?!\d))/g,
          ","
        );

        // Combine integer part with decimal part (if any)
        let formattedNumber = integerWithCommas + decimalPart;

        return formattedNumber;
      }
    },
  },
  mounted() {
    this.show_KYC_modal();
    this.get_sales_dashboard();
    this.get_withdrawls();
    this.get_invoices();
    // this.get_banks_accounts();
  },

  // can remove if it doesnt work
  setup() {
    const dateRangeInput = ref(null);
    onMounted(() => {
      if (dateRangeInput.value) {
        const start = moment().subtract(6, "days");
        const end = moment();

        function booking_range(start, end) {
          start.format("M/D/YYYY") + " - " + end.format("M/D/YYYY");
        }

        new DateRangePicker(
          dateRangeInput.value,
          {
            startDate: start,
            endDate: end,
            ranges: {},
          },
          booking_range
        );

        booking_range(start, end);
      }
    });
    return {
      dateRangeInput,
    };
  },
};
</script>

<style scoped>
.c {
  color: #00afef34;
}
#item_code {
  z-index: 5;
  margin-right: 43%;
  width: 200px;
  cursor: pointer;
  margin-top: -45%;
  float: right;
}

.balance-card {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px;
  height: 96px;
  color: #fff;
  background: #00afef;
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.15);
}

.form-control {
  outline: none;
  font-size: 14px;
  padding: 14px 20px;
  border: none;
  font-style: italic;
  color: #000;
  height: 50px;
  font-weight: 400;
  border-radius: 0;
  border: 1px solid #ddd;
  transition: all 0.4s ease;
  box-shadow: 0 0 0 transparent;
  background-color: transparent;
}

.form-group > label {
  margin-bottom: 1.5rem;
  font-weight: 400;
  color: #000000;
  line-height: 1em;
  font-size: 16px;
  margin-top: 20px;
}
.fg2 > label {
  margin-bottom: 0px;
}
.bal {
  font-family: "Roboto";
  color: #fff;
  font-weight: 600;
  font-size: 28px;
  line-height: 33px;
}
.wallet_icon {
  font-size: 25px;
  color: #00afef;
  background-color: white;
  border-radius: 25%;
  display: inline-block;
  width: 40px;
  height: 40px;
  padding: 8px;
}
.icon_cont {
  margin-right: 10px;
  float: left;
}
#input-1 {
  height: 50px;
}
center {
  margin-top: 20px;
}

.py-2 {
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important;
}
.confirm-desc {
  width: 100%;
  height: 82px;
  border-radius: 16px;
  background: #eaeaea;
  padding: 12px;
}
.confrim-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
element.style {
  font-size: 28px;
  font-weight: 600;
}

.modal-container {
  display: flex;
  gap: 10px;
  margin-bottom: 10px;
  padding: 0px 20px;
}

.modal-container h4 {
  font-size: 16px;
  font-weight: bolder;
}
.modal-container {
  display: flex;
  gap: 10px;
  margin-bottom: 10px;
  padding: 0px 20px;
}
p {
  font-size: 14px;
  line-height: 1.6em;
  font-weight: 500;
}
.name-block {
  display: flex;
  gap: 10px;
  margin-bottom: -20px;
}
</style>
